import { DEFAULT_LOCALE, LOCALE_CODES } from '@/i18n/config';

/**
 * Motore dei campi traducibili di pages.json/settings.json. Un campo
 * traducibile (i18n:true in registry/pagesSchema/settingsSchema) è salvato
 * come mappa { it: '...', en: '...' } invece di stringa — la struttura del
 * blocco (ordine, immagini, link) resta identica per ogni lingua, cambia
 * solo il testo. Le stringhe "legacy" (da prima di questa migrazione)
 * restano valide: vengono trattate come testo della lingua di default.
 */
export function isLocaleMap(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const keys = Object.keys(value);
  return keys.length > 0 && keys.every((k) => LOCALE_CODES.includes(k));
}

/** Risolve ricorsivamente ogni mappa-lingua trovata in un albero di dati (props di un blocco, una pagina...). */
export function resolveLocalizedTree(data, locale) {
  if (Array.isArray(data)) return data.map((v) => resolveLocalizedTree(v, locale));
  if (data && typeof data === 'object') {
    if (isLocaleMap(data)) return data[locale] || data[DEFAULT_LOCALE] || Object.values(data)[0] || '';
    return Object.fromEntries(Object.entries(data).map(([k, v]) => [k, resolveLocalizedTree(v, locale)]));
  }
  return data;
}

/** Valore di un campo i18n per la lingua in editing nell'admin (stringa vuota se non ancora tradotto). */
export function getLocalized(value, locale) {
  if (isLocaleMap(value)) return value[locale] || '';
  return locale === DEFAULT_LOCALE ? (value || '') : '';
}

/** Aggiorna la lingua `locale` di un campo i18n, preservando le altre lingue già presenti. */
export function setLocalized(value, locale, newValue) {
  const map = isLocaleMap(value) ? value : (value ? { [DEFAULT_LOCALE]: value } : {});
  return { ...map, [locale]: newValue };
}
